<template>
  <div class="chapter">
    <span>{{chapter}}</span>
  </div>
</template>

<script>
export default {
  name: 'Chapter',
  props: {
    chapter: String
  }
}
</script>

<style scoped>
  .chapter {
    background: url('../assets/chapter.png') center center no-repeat;
    color: #f26522;
    display: block;
    font-size: 72px;
    height: 147px;
    left: -61px;
    position: absolute;
    top: -96px;
    width: 123px;
    z-index: 2;
  }

  span {
    display: block;
    left: 50%;
    position: relative;
    top: 50%;
    transform: translate(-50%, -40%);
  }
</style>